export function setupProductOverviewModal() {
    
    const toggleFilterBtn = document.getElementById('toggle-filter-btn');
    const closeFilterBtn = document.getElementById('filter-article-close');

    if (toggleFilterBtn && closeFilterBtn) {
        toggleFilterBtn.addEventListener('click', toggleFilterArticleShow);
        closeFilterBtn.addEventListener('click', toggleFilterArticleShow);
    }

    function toggleFilterArticleShow () {
        document.body.classList.toggle('body-show-filters');
    }
};
